module.exports = __webpack_public_path__ + "static/img/btn_more.04e17f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/PR010103/btn_more.png
// module id = 9ITm
// module chunks = 10